import { createAsyncPromise } from '@/helpers/event'

const LOADING_STATUS = {
  loading: 'loading',
  success: 'success',
  failure: 'failure',
}

function getState(script) {
  if (!script.__state) script.__state = {}
  return script.__state
}

function setPromise(script, promise) {
  getState(script).promise = promise
}

function getPromise(script) {
  return getState(script).promise
}

function setStatus(script, status) {
  getState(script).status = status
}

function getStatus(script) {
  return getState(script).status
}

function isStatusLoading(script) {
  return getStatus(script) === LOADING_STATUS.loading
}

function isStatusSuccess(script) {
  return getStatus(script) === LOADING_STATUS.success
}

export function findScriptBySrcRegExp(urlRegExp, { targetEl = document.body } = {}) {
  if (!urlRegExp) throw new Error('Please provide "urlRegExp".')
  const scripts = targetEl.querySelectorAll('script[src]')
  for (let i = scripts.length; i--; ) {
    const script = scripts[i]
    if (urlRegExp.test(script.src)) return script
  }
  return null
}

export function findScriptBySrc(src, options) {
  return findScriptBySrcRegExp(new RegExp(src), options)
}

export function isScriptAddedToDOM(urlRegExp, options) {
  return !!findScriptBySrcRegExp(urlRegExp, options)
}

export function addScriptToDOM(
  src,
  { integrity = '', crossorigin = '', targetEl = document.body } = {}
) {
  const [promise, resolve, reject] = createAsyncPromise()
  const script = src ? findScriptBySrc(src, { targetEl }) : null
  if (script) {
    if (isStatusLoading(script)) return getPromise(script)
    else return new Promise((resolve, reject) => (isStatusSuccess(script) ? resolve() : reject()))
  } else {
    const script = document.createElement('script')
    script.async = true
    script.src = src
    if (integrity) script.setAttribute('integrity', integrity)
    if (crossorigin) script.setAttribute('crossorigin', crossorigin)
    setPromise(script, promise)
    setStatus(script, LOADING_STATUS.loading)
    script.addEventListener('load', () => {
      setStatus(script, LOADING_STATUS.success)
      resolve()
    })
    script.addEventListener('error', () => {
      setStatus(script, LOADING_STATUS.failure)
      reject(new Error(`Loading script failed (src: ${src}).`))
    })
    script.addEventListener('abort', () => {
      setStatus(script, LOADING_STATUS.failure)
      reject(new Error(`Loading script was aborted (src: ${src}).`))
    })
    targetEl.appendChild(script)
  }
  return promise
}
